export default "__VITE_ASSET__DYBuwvxH__"